import React, { useState, Children, cloneElement, useRef } from "react";
import { memo } from "react";
import emailjs from '@emailjs/browser';
import { Mail, Phone } from 'lucide-react';

const GitHub = ({ size = 24, color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M15 22v-4a4.8 4.8 0 0 0-1-3.2c3-.3 6-1.5 6-6.5 0-1.4-.5-2.5-1.5-3.4.1-.3.6-1.6-.1-3.3 0 0-1.2-.4-3.9 1.4a12.3 12.3 0 0 0-7 0C6.2 1.3 5 1.7 5 1.7c-.7 1.7-.2 3-.1 3.3-1 .9-1.5 2-1.5 3.4 0 5 3 6.2 6 6.5-.4.4-.7 1-.8 2-.5.3-1.7.9-2.5 0-.8-.9-1.3-1-1.3-1-.9-.1-1.3.1-1.3.1.5.7.8 1.1 1.4 1.7.6.6 1.6 1 2.3 1" />
  </svg>
);

const LinkedIn = ({ size = 24, color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
    <rect width="4" height="12" x="2" y="9" />
    <circle cx="4" cy="4" r="2" />
  </svg>
);
// import { Document } from 'react-pdf';
// import { pdfjs } from 'react-pdf';
// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const HomePage = () => {
    return(
        <>
        <h2>Home</h2>
        <p>
            Hey I am Tadg O'Hare, a recent computer science graduate from Carleton University. I am currently navigating the new-grad life and looking to start my career in the tech world.In my free time I enjoy skiing, and went on weekly trips to Mont Tremblant with the Carleton Ski Club. When the weather is nicer outside you will find me on my road bike or at the beach.
        </p>
        <img src="/collage.png" alt="Collage containing various pictures of me" width="50%" height="50%" id="collage"/>
        <p>
            While I am eager and quick to learn any new framework, language, or software that is thrown at me, these are some of the programming languages & frameworks that I have regularly used in the last couple of years:
        </p>
        <ul>
            <li><strong>Languages:</strong> C/C++/C#, Python, Java</li>
            <li><strong>Frontend:</strong> React, HTML</li>
            <li><strong>Databases:</strong> PostgreSQL, Dataverse, MongoDB (Mongoose)</li>
            <li><strong>Libraries & APIs:</strong> Qt, OpenAI</li>
            <li><strong>Scripting:</strong> DAX & VBS (Excel, Power BI)</li>
        </ul>
        <p>
            On top of the listed languages & frameworks, here is some of the software that I have used extensively throughout my time working for the Government of Canada:
        </p>
        <ul>
            <li><strong>Data & Analytics:</strong> Excel, Power BI, Fabric</li>
            <li><strong>Automation:</strong> Power Automate</li>
            <li><strong>Administration:</strong> SharePoint Admin</li>
            <li><strong>Front-end Design:</strong> Canvas, Brightspace</li>
            <li><strong>Productivity:</strong> Microsoft Office Suite (Word, Teams, PowerPoint)</li>
        </ul>
        
        </>
    );
};

const ResumePage = () => {
    const pdfUrl = "https://raw.githack.com/tadgohare/ResumeLatex/master/main.pdf";
    return(
        <>
        <h2>Resume</h2>
        <iframe className="resume-frame" src={pdfUrl} width="100%" height="600px" title="Resume PDF"></iframe>
        {/* <Document file="/Tadg_Resume___2024.pdf" /> */}
        </>
    );
};
const ContactPage = () => {
    //form handler functions
    const form = useRef();
    const [formState, setFormState] = useState({
        name: '',
        email: '',
        message: ''
    });
    const handleChange = (e) => {
        setFormState({
            ...formState,
            [e.target.name]: e.target.value
        });
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(formState);
        emailjs.sendForm('service_a5kog9e', 'template_1h0mk0f', form.current, {publicKey:'Txb6daWDLCuhfBx4B',})
        .then(
            () => {
                console.log("Message sent successfully!");
                setFormState({
                    name: '',
                    email: '',
                    message: ''
                });
                alert("Message successfully sent!");

            },
            (error) => {
                console.log("Message failed to send", error);
                alert("Message failed to send, make sure you typed in the correct information and try again.");
            },
        );
    };
    //HTML component
    return(
        <>
        <h2>Reach out to me</h2>
        <p>You can reach me using any of the information listed below:</p>
        <ul style={{ listStyle: 'none', padding: 0 }}>
            <li style={{ display: 'flex', alignItems: 'center', gap: '0.5em' }}>
                <Mail size={20} /> <a href="mailto:contact@tadg.ca">contact@tadg.ca</a>
            </li>
            <li style={{ display: 'flex', alignItems: 'center', gap: '0.5em' }}>
                <Phone size={20} /> <a href="tel:+12897002048">+1 (289) 700-2048</a>
            </li>
            <li style={{ display: 'flex', alignItems: 'center', gap: '0.5em' }}>
                <GitHub size={20} /> <a href="https://github.com/tadgohare">GitHub</a>
            </li>
            <li style={{ display: 'flex', alignItems: 'center', gap: '0.5em' }}>
                <LinkedIn size={20} /> <a href="https://linkedin.com/in/tadg-ohare">LinkedIn</a>
            </li>
        </ul>
        <div className="contactForm">
            <h2>Send me a message</h2>
            <p className="contactForm-description">I’d love to hear from you. Share your project, question, or availability and I’ll get back to you soon.</p>
            <form ref={form} onSubmit={handleSubmit} className="contactForm-form">
                <label className="contactForm-field">
                    <span>Name</span>
                    <input 
                        type="text" 
                        name="name" 
                        value={formState.name} 
                        onChange={handleChange} 
                        placeholder="Your name"
                        required
                    />
                </label>
                <label className="contactForm-field">
                    <span>Email</span>
                    <input 
                        type="email" 
                        name="email" 
                        value={formState.email} 
                        onChange={handleChange} 
                        placeholder="your@email.com"
                        required
                    />
                </label>
                <label className="contactForm-field">
                    <span>Message</span>
                    <textarea 
                        name="message" 
                        value={formState.message} 
                        onChange={handleChange} 
                        placeholder="Tell me how I can help"
                        required
                    />
                </label>
                <div className="contactForm-actions">
                    <button type="submit">Send message</button>
                </div>
            </form>
        </div>
        {/* <iframe 
            title="Github Contributions"
            src="https://ghchart.rshah.org/409ba5/tadgohare" 
            style={{border: "0",overflow:"hidden"}} 
            width="600" 
            height="170" 
            allowtransparency="true">
        </iframe> */}
        </>
    );
};

const pages = [<HomePage />, <ResumePage />, <ContactPage />];


const Tab = ({ title, setTab, index, activeTab}) => (
    <button 
        className={`buttonTab ${activeTab === index ? 'activeTab' : ''}`}
        onClick={() => setTab(index)}
    >
        {title}
    </button>
);


const Tabs = ({ children }) => {
    const [currentTab, setTab] = useState(0);
    return (
        <div>
            <div className="tabs">
                {Children.map(children, (child, index) => {
                    return cloneElement(child, { currentTab, setTab, index, activeTab: currentTab })
                })}
            </div>
            <div className="tab-content">
                {pages[currentTab]}
            </div>
        </div>
    );
};


const Page = () => {
    return(
        <div className="container">
        <h1>Tadg O'Hare</h1>
        <Tabs>
            <Tab title="Home"></Tab>
            <Tab title="Resume"></Tab>
            <Tab title="Contact"></Tab>
        </Tabs>
        </div>
    );
    };

export default memo(Page);